import React, { 
	useState, 
	useEffect 
} from 'react'
import { useSelector } from 'react-redux'

import RouteConstants from '../routes'
import { Link } from 'react-router-dom'

import ErrorDisplay from './ErrorDisplay';

import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';

import useMediaQuery from '@mui/material/useMediaQuery';
import useStyles from '../styles/Styles'

import _ from 'lodash';

const HomeCard = (props) => {
	const route = props.route;
	const classes = useStyles();
	const courseLabels = useSelector(state => state.settings.labels_courses.data);
	
	return (
	<Grid item xs={12} sm={6} >
	<Card className={classes.homeCard} >
		<CardActionArea component={Link} to={route.path} className={classes.cardLink}>
		{route.icon ? 
			route.icon
			: null}
		<CardContent >
			<Typography variant="h5" component="h2">
			{route.title === 'Courses' ? courseLabels.coursesCapLabel : route.title}
			</Typography>
			{route.subtext ? (
				<Typography variant="body2" component="p">
				{route.subtext}
				</Typography>
			)
			: null}
		
		</CardContent>
		</CardActionArea>
	</Card>
	</Grid>
)};

const Home = () => {
	const filteredLinks = useSelector(state => state.settings.links);
	const generalSettings = useSelector(state => state.settings.general.data);
	const user = useSelector(state => state.user);
	const classes = useStyles();
	const isXS = useMediaQuery('(max-width:600px)');
	
	const [cards, setCards] = useState([]);
	useEffect(() => {
		if(user && user.member_no > 0){
			setCards(_.chain(RouteConstants).pick(filteredLinks).filter({card: true, loggedin: true})
			.map(v => {
				if(v.title === 'My Membership'){
					v.subtext = user.full_name;
				} else if(v.title === 'Courses'){
					v.subtext = generalSettings.courses_link_text;
				}
				return v;
			})
			.value())
			
		} else {
			setCards(_.chain(RouteConstants).pick(filteredLinks).filter({card: true, loggedout: true})
			.map(v => {
				if(v.title === 'Courses'){
					v.subtext = generalSettings.courses_link_text;
				}
				return v;
			})
			.value())
		}
	}, [user, filteredLinks, generalSettings.courses_link_text]);
	
	return (
	<div className={window.$umas4m_config.embedded ? classes.homeCardsEmbedded : classes.homeCards}>
	<ErrorDisplay />
	<Grid container 
	  spacing={isXS ? 2 : 3} 
	>
	{cards.map((route, i) => (
		<HomeCard key={i} route={route} />
	))}
	</Grid>
	</div>
)};

export default Home